module.exports = __webpack_public_path__ + "static/media/group--mold.01270eba.svg";